<template>
  <div class="fantan-category">
    <fantan-main-bet
      :game="game"
      :game-data="gameData"
      :disallow-betting="disallowBetting"
      :minutes-string="minutesString"
      :seconds-string="secondsString"
      :count-down="countDown"
      :showDrawingAnimation="showDrawingAnimation"
      :draw-result="drawResult"
    />
    <Tabs
      class="tab-nav"
      value="nim"
      name="first"
      size="small"
      :animated="false"
      @on-click="clickTab"
    >
      <TabPane ref="sshTab" :label="SSH" name="ssh" :disabled="disableTab || isSsh">
        <!-- <fantan-main-bet
          :game="game"
          :game-data="gameData"
          :disallow-betting="disallowBetting"
          :minutes-string="minutesString"
          :tabChanges="isSsh"
          :seconds-string="secondsString"
          :count-down="countDown"
          :showDrawingAnimation="showDrawingAnimation"
          :draw-result="drawResult"
        />-->
        <fantan-ssh-bet
          :game="game"
          :game-data="gameData"
          :animation="isSsh"
          @on-tab-end="tabOnAnimationEnd"
          :disallow-betting="disallowBetting"
          :minutes-string="minutesString"
          :seconds-string="secondsString"
          :count-down="countDown"
          :draw-result="drawResult"
        />
      </TabPane>

      <TabPane ref="nimTab" :label="NIM" name="nim" :disabled="disableTab || isNim">
        <!-- <fantan-main-bet
          :game="game"
          :game-data="gameData"
          :disallow-betting="disallowBetting"
          :minutes-string="minutesString"
          :seconds-string="secondsString"
          :count-down="countDown"
          :tabChanges="isNim"
          :showDrawingAnimation="showDrawingAnimation"
          :draw-result="drawResult"
        />-->

        <fantan-kwok-bet
          :game="game"
          :game-data="gameData"
          :disallow-betting="disallowBetting"
          :minutes-string="minutesString"
          :seconds-string="secondsString"
          :count-down="countDown"
          :draw-result="drawResult"
        />

        <fantan-nim-bet
          :game="game"
          :game-data="gameData"
          :animation="isNim"
          @on-tab-end="tabOnAnimationEnd"
          :disallow-betting="disallowBetting"
          :minutes-string="minutesString"
          :seconds-string="secondsString"
          :count-down="countDown"
          :draw-result="drawResult"
        />
      </TabPane>

      <TabPane ref="ngaTab" :label="NGA" name="nga" :disabled="disableTab || isNga">
        <!-- <fantan-main-bet
          :game="game"
          :game-data="gameData"
          :disallow-betting="disallowBetting"
          :minutes-string="minutesString"
          :seconds-string="secondsString"
          :count-down="countDown"
          :tabChanges="isNga"
          :showDrawingAnimation="showDrawingAnimation"
          :draw-result="drawResult"
        />-->

        <fantan-kwok-bet
          :game="game"
          :game-data="gameData"
          :disallow-betting="disallowBetting"
          :minutes-string="minutesString"
          :seconds-string="secondsString"
          :count-down="countDown"
          :draw-result="drawResult"
        />

        <fantan-nga-bet
          :game="game"
          :game-data="gameData"
          :animation="isNga"
          @on-tab-end="tabOnAnimationEnd"
          :disallow-betting="disallowBetting"
          :minutes-string="minutesString"
          :seconds-string="secondsString"
          :count-down="countDown"
          :draw-result="drawResult"
        />
      </TabPane>
    </Tabs>
  </div>
</template>
<script>
import { Tabs, TabPane, Row, Col } from "iview";
import { TweenLite, TimelineLite } from "gsap";
import { forEach } from "lodash";
import FantanNimBet from "./FantanNimBet";
import FantanNgaBet from "./FantanNgaBet";
import FantanSshBet from "./FantanSshBet";
import FantanKwokBet from "./FantanKwokBet";
import FantanMainBet from "./FantanMainBet";
import betLotMixin from "../../../mixins/bet-lot-mixin";
import { titleCase, snakeCase } from "change-case";

export default {
  mixins: [betLotMixin],
  props: [
    "game",
    "winCellNo",
    "gameData",
    "drawResult",
    "showDrawingAnimation",
    "disallowBetting",
    "displayDisallowSection",
    "minutesString",
    "secondsString",
    "countDown",
  ],
  components: {
    Tabs,
    TabPane,
    Row,
    Col,
    FantanNimBet,
    FantanNgaBet,
    FantanSshBet,
    FantanKwokBet,
    FantanMainBet,
  },
  data() {
    return {
      FAN: (h) => {
        return h("div", this.$t("fantan.fan"));
      },
      SSH: (h) => {
        return h("div", this.$t("fantan.ssh"));
      },
      KWOK: (h) => {
        return h("div", this.$t("fantan.kwok"));
      },
      NIM: (h) => {
        return h("div", this.$t("fantan.nim"));
      },
      NGA: (h) => {
        return h("div", this.$t("fantan.nga"));
      },
      isSsh: false,
      isNga: false,
      isNim: false,
      disableTab: false,
    };
  },
  watch: {
    isSsh(newVal) {
      if (!newVal) {
        if (this.isNim) {
          TweenLite.fromTo(
            this.$refs["nimTab"].$el,
            0.5,
            {
              opacity: 0,
            },
            {
              opacity: 1,
            }
          );
        } else if (this.isNga) {
          TweenLite.fromTo(
            this.$refs["ngaTab"].$el,
            0.5,
            {
              opacity: 0,
            },
            {
              opacity: 1,
            }
          );
        }
      }
    },
  },
  computed: {},
  mounted() {},
  methods: {
    clickTab(name) {
      if (name == "ssh") {
        this.isSsh = true;
        this.isNga = false;
        this.isNim = false;
        this.disableTab = true;
      } else if (name == "nga") {
        this.isNga = true;
        this.isSsh = false;
        this.isNim = false;
        this.disableTab = true;
      } else if (name == "nim") {
        this.isNim = true;
        this.isSsh = false;
        this.isNga = false;
        this.disableTab = true;
      }
    },
    tabOnAnimationEnd() {
      this.disableTab = false;
    },
  },
};
</script>
<style lang="scss" >
.fantan-bowl {
  z-index: 10;
}

.fantan-category {
  position: relative;
}
.fantan-category .ivu-tabs-bar {
  margin-bottom: 0px;
  position: absolute;
  z-index: 1;
  top: -45%;
  transform: translateY(50%);
  right: 0;
  padding: 0 10px;
  border: transparent;
}
.fantan-category .ivu-tabs {
  background: transparent linear-gradient(180deg, #474b4c 0%, #111113 100%) 0%
    0% no-repeat padding-box;
  overflow: visible;
}

.fantan-category .ivu-tabs-nav-scroll {
  border: 0;
}
.fantan-category .ivu-tabs .ivu-tabs-tabpane {
  // border-top: 1px solid #707070;
}
.fantan-category .ivu-tabs-mini .ivu-tabs-tab {
  font-family: "Barlow";
  font-size: 13px;
  text-align: center;
  color: #f0eded;
  background: transparent linear-gradient(180deg, #686f71 0%, #383845 100%) 0%
    0% no-repeat padding-box;
  box-shadow: 0px 3px 2px #00000029;
  border-radius: 10px;
  width: 54px;
  height: 24px;
  padding: 2px 0;
  margin: 0 0 3px;
}
.fantan-category .ivu-tabs-nav {
  // display: flex;
  // justify-content: space-between;
  // float: none;
  //   border-bottom: 4px #dce5f8 solid;

  display: grid;
  justify-content: center;
  float: right;
}
.fantan-category .ivu-tabs-ink-bar {
  left: 0;
  width: 0% !important;
}
.fantan-category .ivu-tabs-nav .ivu-tabs-tab-active {
  color: #f0eded;
  position: relative;
  // display: none;
  // background: transparent;
}
// .fantan-category .ivu-tabs-nav .ivu-tabs-tab-active:after {
//   position: absolute;
//   content: "";
//   height: 2px;
//   bottom: -2px;
//   margin: 0 auto;
//   left: 0;
//   right: 0;
//   width: 100%;
//   background: #0032ac;
// }

.fantan-category .ivu-tabs-nav .ivu-tabs-tab:hover {
  color: #f0eded;
  background: linear-gradient(#a4afb2, #757d80);
  border: #707070;
  padding: 2px;
}
.fantan-disallow-betting-section {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 130%;
  overflow: hidden;
  color: white;
  background: rgba(#000000, 0.9);
  font-size: 16px;
  z-index: 11;
}
.fantan-category .ivu-tabs-tab.ivu-tabs-tab-disabled {
  background: linear-gradient(#a4afb2, #757d80);
  border: #707070;
}
.fantan-category .ivu-tabs-tab.ivu-tabs-tab-active.ivu-tabs-tab-focused {
  background: linear-gradient(#a4afb2, #757d80);
  border: #707070;
}
</style>